import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getItemApi } from '../../../apiUtils';
import { Loader } from '../../../components/loader/Loader';
import { Asset } from '../../../types/asset.types';
import { API_URL } from '../../../utils/apiUrl';
import MobileLayout from '../../Tasks/Mobile/components/MobileLayout';
import * as Bar from '../../WorkSheets/Mobile/components/Bar';
import { ParametersMeasuringButtons } from './ParametersMeasuringButtons';
import { ParametersMeasuringLast } from './ParametersMeasuringLast';

export interface PageParams {
  assetId: string;
}

export const ParametersMeasuringPage = () => {
  const history = useHistory();
  const { assetId } = useParams<PageParams>();

  const [asset, setAsset] = useState<Asset | null>(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    getAsset();
  }, []);

  const getAsset = async () => {
    setLoading(true);
    await getItemApi<Asset>({
      url: `${API_URL.ASSET_ITEM}`,
      params: {
        id: assetId,
      },
      callAfterSuccess: (result) => {
        setAsset(result);
      },
    });
    setLoading(false);
  };

  const handleSelectParameter = (assetParameterId: number) => {
    history.push(`/mobile/parameters-measuring/create/${assetId}/${assetParameterId}`);
  };

  if (isLoading || !asset) return <Loader />;

  return (
    <MobileLayout>
      <Bar.SummaryNavBar
        title={`${asset.topLevelParenName} - ${asset.name!}`}
        onBack={() =>
          history.push({
            pathname: '/mobile',
          })
        }
      />
      <ParametersMeasuringLast assetId={Number(assetId)} />
      <ParametersMeasuringButtons
        assetId={Number(assetId)}
        onSelectParameter={handleSelectParameter}
      />
    </MobileLayout>
  );
};
